// 9fbef606107a605d69c0edbcd8029e5d
import ADYENPAYMENT_CONSTANTS from './AdyenPayment.constants';

export const startAdyenPaymentAction = (payload) => {
  return {
    type: ADYENPAYMENT_CONSTANTS.START_ADYEN_PAYMENT,
    payload,
  };
};

export const setAdyenSessionData = (payload) => {
  return {
    type: ADYENPAYMENT_CONSTANTS.SET_ADYEN_SESSION_DATA,
    payload,
  };
};

export const setAdyenSetupData = (payload) => {
  return {
    type: ADYENPAYMENT_CONSTANTS.SET_ADYEN_SETUP_DATA,
    payload,
  };
};

export const createAdyenSessionAction = (payload) => {
  return {
    type: ADYENPAYMENT_CONSTANTS.CREATE_ADYEN_SESSION,
    payload,
  };
};

export default startAdyenPaymentAction;
